<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 10:07:39
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-06 10:07:41
 * @FilePath: \YunYin_admin\src\views\Village\SetQuery\index.vue
-->
<template>
  <router-view />
</template>

<script>
  export default {
    name: "VillageSetQuery",
  };
</script>